import { cn } from "@/utils/cn";
import { cva, VariantProps } from "class-variance-authority";
import * as React from "react";

const ColoredCardVariants = cva("flex w-full", {
  variants: {
    color: {
      neutral: "bg-surface-light",
      yellow: "bg-tag-yellow-soft",
      blue: "bg-tag-blue-soft",
      red: "bg-tag-red-soft",
    },
    direction: {
      row: "flex-row items-center",
      col: "flex-col",
    },
    spacing: {
      none: "gap-0",
      xs: "gap-1",
      sm: "gap-2",
      md: "gap-3",
      lg: "gap-4",
      xl: "gap-6",
    },
    corner: {
      none: "rounded-none",
      sm: "rounded-xs",
      md: "rounded-md",
      lg: "rounded-lg",
      xl: "rounded-xl",
      full: "rounded-full",
    },
    padding: {
      none: "p-0",
      xs: "px-2 py-1.5",
      sm: "px-3 py-2",
      md: "px-4 py-3",
      lg: "px-4 py-5",
      xl: "px-6 py-6",
    },
  },
  defaultVariants: {
    color: "neutral",
    direction: "row",
    spacing: "md",
    corner: "md",
    padding: "md",
  },
});

export type ColoredCardProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof ColoredCardVariants>;

export const ColoredCard = React.forwardRef<HTMLDivElement, ColoredCardProps>(
  (
    { className, color, direction, spacing, corner, padding, ...props },
    ref,
  ) => (
    <div
      data-component="ColoredCard"
      ref={ref}
      className={cn(
        ColoredCardVariants({ color, direction, spacing, corner, padding }),
        className,
      )}
      {...props}
    />
  ),
);

ColoredCard.displayName = "ColoredCard";

export default ColoredCard;
